import { PhoneZ } from "@patient-watch/types";
import { z } from "zod";

export const smartAuthSchema = z
    .object({
        contactMethod: z.enum(["email", "phone"]),
        email: z.preprocess(
            (v) => (v === "" || v === null || v === undefined ? undefined : v),
            z.string().email().optional()
        ),
        phone: z.preprocess((v) => (v === "" || v === null || v === undefined ? undefined : v), PhoneZ.optional()),
    })
    .superRefine((data, ctx) => {
        if (data.contactMethod === "email") {
            if (!data.email) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Enter your email address",
                    path: ["email"],
                });
            }
        } else if (!data.phone) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Enter your phone number",
                path: ["phone"],
            });
        }
    });

export type SmartAuthSchemaType = z.infer<typeof smartAuthSchema>;
